import { useQuery } from '@apollo/client/react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { GET_PROPERTY_TYPES } from '@modules/_shared/common/queries';
import { buildTransactionPreviewItem } from '@modules/_shared/components/create-transaction/buildTransactionPreviewItem';
import type { TransactionFormData } from '@modules/_shared/components/create-transaction/hooks/useTransactionStepper';
import { TransactionPreviewCard } from '@modules/_shared/components/create-transaction/TransactionPreviewCard';
import { TransactionStepHeader } from '@modules/_shared/components/create-transaction/TransactionStepHeader';
import { GET_BROKER_AND_TEAM_NAMES } from '@modules/transactions/transactionQueries';
import { useLocale } from '@shared/hooks/locale';

export const PreviewStep: React.FC = () => {
  const { t, locale } = useLocale();
  const { getValues } = useFormContext<TransactionFormData>();
  const formData = getValues();
  const { details } = formData;

  const { data: propertyTypesData } = useQuery(GET_PROPERTY_TYPES);
  const hasTeam = !!details?.seller_broker_team_id;
  const { data: stakeholderData } = useQuery(GET_BROKER_AND_TEAM_NAMES, {
    variables: {
      broker_id: details?.seller_broker_id ?? '',
      team_id: details?.seller_broker_team_id ?? '',
      include_team: hasTeam,
    },
    skip: !details?.seller_broker_id,
  });

  const previewItem = buildTransactionPreviewItem({
    formData,
    propertyTypes: propertyTypesData?.property_types ?? [],
    locale,
    t,
    brokerName: stakeholderData?.broker?.full_name,
    teamName: stakeholderData?.team?.name,
  });

  return (
    <Box sx={{ p: 2 }}>
      <TransactionStepHeader
        title={t('Preview')}
        subtitle={t(
          'As the transaction will be displayed on your agent profile',
        )}
        subtitleSx={{ mb: 0, pb: 2 }}
      />
      <TransactionPreviewCard layout="form" item={previewItem} />
    </Box>
  );
};
